import { Image } from "antd";
import React, { useEffect, useState } from "react";

import entete from '../../../assets/img/entete_pool.png';
import PropTypes from "prop-types";
import { frenchDate, frenchDateOnly } from "../../../variables/functions";
import { displayNumbers } from "../../../variables/numbersFunctions";
import { getCompagnieLogo } from "../../../hooks/useFilesHooks";
import { DocumentFooter } from "../../../components/docs/DocumentFooter";
import BarreTop from "../../../components/docs/BarreTop";

const FicheDemandeReglementSinistre = React.forwardRef((props, ref) => {
    const [cumulPaye, setCumulPaye] = useState(0);
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);

    const getSortDossier = (sort) => {
        const sortMap = {
            "I": "EN INSTANCE",
            "O": "OUVERT",
            "Rf": "REFUSÉ",
            "RF": "REFUSÉ",
            "T": "TERMINE",
            "S": "SANS SUITE",
            "R": "REOUVERT"
        };
        return sortMap[sort] || "EN INSTANCE";
    };

    useEffect(() => {
        if (props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL") {
            getCompagnieLogo(props?.sinistre?.contrat?.organisme?.code)
                .then(async (response) => {
                    const imageBytes = await response.arrayBuffer();
                    var blob = new Blob([imageBytes], { type: "image/png" });
                    var imageUrl = URL.createObjectURL(blob);
                    setLogoPreviewUrl(imageUrl);
                })
                .catch((error) => {
                    console.log(error);
                });
        }

        // Add print style for portrait orientation
        const style = document.createElement('style');
        style.innerHTML = `
            @media print {
                @page {
                    size: portrait;
                    margin: 0;
                }
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    useEffect(() => {
        if (props?.sinistre?.decaissements) {
            let cumul = 0.0;
            props?.sinistre?.decaissements.forEach((decaissement) => {
                cumul += parseFloat(decaissement.montantGlobal);
            });
            setCumulPaye(cumul);
        }
    }, [props?.decaissement?.sinistre?.decaissements, props?.sinistre?.decaissements]);

    const sinistre = props.sinistre;
    const decaissement = props.decaissement;

    return (
        <div ref={ref} style={{
            width: "210mm",
            minHeight: "297mm",
            margin: "0 auto",
            backgroundColor: "white",
            fontFamily: "'Comic Sans MS', 'Comic Sans', cursive, sans-serif",
            fontSize: "12px",
            boxSizing: "border-box",
            position: "relative"
        }}>
            {/* Header - Full Width */}
            <div style={{
                marginBottom: "10px",
                paddingBottom: "10px"
            }}>
                <div style={{ flexShrink: 0 }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0px 0px",
                        }}
                    >
                        {props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL" && (
                            <Image
                                src={logoPreviewUrl}
                                style={{
                                    width: "100%",
                                    height: "105px",
                                }}
                            />
                        )}

                        <Image
                            src={entete}
                            style={{
                                width: "100%",
                                height: "105px",
                            }}
                        />
                    </div>
                    <BarreTop />
                </div>

            </div>

            {/* Content Area with Padding */}
            <div style={{ padding: "0 20mm" }}>

                <div style={{
                    textAlign: "center",
                    fontSize: "22px",
                    fontWeight: "bold",
                    WebkitTextStroke: "0.5px black",
                    marginBottom: "15px",
                    marginTop: "15px",
                    border: "1px solid black",
                    color: "black"
                }}>
                    FICHE DE DEMANDE DE REGLEMENT SINISTRE
                </div>
                {/* Info Grid */}
                <table style={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: "4px 4px", // horizontal | vertical spacing
                    marginBottom: "20px",
                    fontSize: "12px",
                    color: "black"
                }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: "2px 4px", width: "20%", border: "1px solid black" }}>Sinistre N°</td>
                            <td style={{ padding: "2px 4px", width: "30%", border: "1px solid black", textAlign: "right" }}>
                                {sinistre?.numeroSinistreM || sinistre?.numSinistre || ""}
                            </td>
                            <td style={{ width: "3px" }} /> {/* SPACE CELL */}
                            <td style={{ padding: "2px 4px", width: "20%", border: "1px solid black" }}>Police N°</td>
                            <td style={{ padding: "2px 4px", width: "30%", border: "1px solid black", textAlign: "right" }}>
                                {sinistre?.contrat?.numeroPoliceM || sinistre?.contrat?.numeroPoliceP || ""}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "2px 4px", border: "1px solid black" }}>Date de survenance</td>
                            <td style={{ padding: "2px 4px", border: "1px solid black", textAlign: "right" }}>
                                {frenchDateOnly(sinistre?.dateSinistre) || ""}
                            </td>
                            <td style={{ width: "3px" }} /> {/* SPACE CELL */}
                            <td style={{ padding: "2px 4px", border: "1px solid black" }}>Effet</td>
                            <td style={{ padding: "2px 4px", border: "1px solid black", textAlign: "right" }}>
                                {frenchDateOnly(sinistre?.contrat?.dateEffet) || ""}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "2px 4px", border: "1px solid black" }}>Date de Déclaration</td>
                            <td style={{ padding: "2px 4px", border: "1px solid black", textAlign: "right" }}>
                                {frenchDateOnly(sinistre?.createdAt) || ""}
                            </td>
                            <td style={{ width: "3px" }} /> {/* SPACE CELL */}
                            <td style={{ padding: "2px 4px", border: "1px solid black" }}>Echéance</td>
                            <td style={{ padding: "2px 4px", border: "1px solid black", textAlign: "right" }}>
                                {frenchDateOnly(sinistre?.contrat?.dateEcheance) || ""}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "2px 4px", border: "1px solid black" }}>Branche</td>
                            <td style={{ padding: "2px 4px", border: "1px solid black", textAlign: "right" }}>
                                {sinistre?.engin?.categorie?.codeCategorie || ""}
                            </td>
                            <td style={{ width: "3px" }} /> {/* SPACE CELL */}
                            <td style={{ padding: "2px 4px", border: "1px solid black" }}>Assuré</td>
                            <td style={{ padding: "2px 4px", border: "1px solid black", textAlign: "right" }}>
                                {sinistre?.contrat?.souscripteur?.prenom
                                    ? `${sinistre?.contrat?.souscripteur?.nom} ${sinistre?.contrat?.souscripteur?.prenom}`
                                    : sinistre?.contrat?.souscripteur?.nom}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Section: Situation Financière */}
                <div style={{
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: "normal",
                    textDecoration: "underline",
                    margin: "20px 0 15px 0",
                    color: "black"
                }}>
                    SITUATION FINANCIERE DU DOSSIER
                </div>

                <table style={{
                    width: "100%",
                    borderCollapse: "separate",
                    marginBottom: "20px",
                    fontSize: "12px",
                    color: "black"
                }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: "4px 8px", width: "30%", border: "1px solid black" }}>Coût total prévisible</td>
                            <td style={{ padding: "4px 8px", width: "20%", border: "1px solid black", textAlign: "right" }}>
                                {displayNumbers(Math.trunc(sinistre?.evaluation))}
                            </td>
                            <td style={{ width: "3px" }} /> {/* SPACE CELL */}
                            <td style={{ padding: "4px 8px", width: "30%", border: "1px solid black" }}>Prévision de recours</td>
                            <td style={{ padding: "4px 8px", width: "20%", border: "1px solid black", textAlign: "right" }}>{displayNumbers(Math.trunc(sinistre?.evaluationRecours || 0))}</td>
                        </tr>
                        <tr>
                            <td style={{ padding: "4px 8px", border: "1px solid black" }}>Cumul des paiements</td>
                            <td style={{ padding: "4px 8px", border: "1px solid black", textAlign: "right" }}>
                                {displayNumbers(Math.trunc(cumulPaye))}
                            </td>
                            <td style={{ width: "3px" }} /> {/* SPACE CELL */}
                            <td style={{ padding: "4px 8px" }}></td>
                            <td style={{ padding: "4px 8px", textAlign: "right" }}></td>
                        </tr>
                        <tr>
                            <td style={{ padding: "4px 8px", border: "1px solid black" }}>SAP</td>
                            <td style={{ padding: "4px 8px", border: "1px solid black", textAlign: "right" }}>
                                {displayNumbers(Math.trunc((sinistre?.sap)))}
                            </td>
                            <td style={{ width: "3px" }} /> {/* SPACE CELL */}
                            <td style={{ padding: "4px 8px", border: "1px solid black" }}>Sort du dossier</td>
                            <td style={{ padding: "4px 8px", border: "1px solid black", textAlign: "right" }}>
                                {getSortDossier(decaissement?.sinistre?.sortDossier)}
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Section: Demande de Règlement */}
                <div style={{
                    textAlign: "center",
                    fontSize: "13px",
                    fontWeight: "normal",
                    textDecoration: "underline",
                    margin: "20px 0 15px 0",
                    color: "black"
                }}>
                    DEMANDE DE REGLEMENT {decaissement?.dateReglement ? "DU " : ""}{frenchDate(decaissement?.dateReglement)}
                </div>

                <table style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "30px",
                    fontSize: "12px",
                    color: "black"
                }}>
                    <tbody>
                        <tr>
                            <td style={{ padding: "4px 8px", width: "30%" }}>Bénéficiaire</td>
                            <td style={{ padding: "4px 8px" }}>
                                {decaissement?.beneficiaire?.prenom
                                    ? `${decaissement?.beneficiaire?.nom} ${decaissement?.beneficiaire?.prenom}`
                                    : decaissement?.beneficiaire?.nom}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "4px 8px" }}>Nature</td>
                            <td style={{ padding: "4px 8px" }}>
                                {decaissement?.nature}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "4px 8px" }}>Motif</td>
                            <td style={{ padding: "4px 8px" }}>
                                {decaissement?.motifReglement || decaissement?.formuleDeFin || ""}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "4px 8px" }}>Montant</td>
                            <td style={{ padding: "4px 8px" }}>
                                {displayNumbers(Math.trunc(decaissement?.montantGlobal || 150000))} FCFA
                            </td>
                        </tr>
                        <tr>
                            <td style={{ padding: "4px 8px" }}>Après une retenue de</td>
                            <td style={{ padding: "4px 8px" }}>
                                {decaissement?.montantPaye
                                    ? displayNumbers(
                                        Math.trunc(
                                            (decaissement?.montantGlobal || 0) -
                                            (decaissement?.montantPaye || 0)
                                        )
                                    )
                                    : "0"} FCFA
                            </td>
                        </tr>
                    </tbody>
                </table>

                {/* Section: Visa et Autorisation */}
                <div style={{
                    fontSize: "13px",
                    fontWeight: "normal",
                    textDecoration: "underline",
                    marginTop: "40px",
                    marginBottom: "20px",
                    textAlign: "center",
                    color: "black"
                }}>
                    VISA ET AUTORISATION
                </div>

                <table style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "20px",
                    fontSize: "12px",
                    border: "1px solid black",
                    color: "black"
                }}>
                    <tbody>
                        <tr>
                            <td style={{
                                textAlign: "center",
                                border: "1px solid black",
                                width: "33.33%"
                            }}>
                                REDACTEUR
                            </td>
                            <td style={{
                                textAlign: "center",
                                border: "1px solid black",
                                width: "33.33%"
                            }}>
                                DIRECTEUR DES OPERATIONS
                            </td>
                            <td style={{
                                textAlign: "center",
                                border: "1px solid black",
                                width: "33.33%"
                            }}>
                                DIRECTEUR DU POOL
                            </td>
                        </tr>
                        <tr>
                            <td style={{
                                padding: "60px 10px 10px 10px",
                                textAlign: "center",
                                textDecoration: "underline",
                                border: "1px solid black",
                                width: "33.33%"
                            }}>

                            </td>
                            <td style={{
                                padding: "60px 10px 10px 10px",
                                textAlign: "center",
                                textDecoration: "underline",
                                border: "1px solid black",
                                width: "33.33%"
                            }}>
                            </td>
                            <td style={{
                                padding: "60px 10px 10px 10px",
                                textAlign: "center",
                                textDecoration: "underline",
                                border: "1px solid black",
                                width: "33.33%"
                            }}>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Footer - Full Width */}
            <div style={{
                position: "absolute",
                bottom: "15mm",
                left: "0",
                right: "0",
                fontSize: "9px",
                textAlign: "center",
                color: "#666",
                borderTop: "1px solid #ccc",
                paddingTop: "10px"
            }}>
                <DocumentFooter />
            </div>
        </div>
    );
});

FicheDemandeReglementSinistre.propTypes = {
    decaissement: PropTypes.object,
    sinistre: PropTypes.object,
};

export default FicheDemandeReglementSinistre;